"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProxyBus = void 0;

var _valid = _interopRequireDefault(require("semver/functions/valid"));

var _major = _interopRequireDefault(require("semver/functions/major"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const packageJson = {
  name: "@nextcloud/event-bus",
  version: "2.0.0",
  description: "",
  main: "dist/index.js",
  types: "dist/index.d.ts",
  scripts: {
    build: "babel ./lib --out-dir dist --extensions '.ts,.tsx' --source-maps && tsc --emitDeclarationOnly",
    "build:doc": "typedoc --out dist/doc lib/index.ts && touch dist/doc/.nojekyll",
    "check-types": "tsc",
    dev: "babel ./lib --out-dir dist --extensions '.ts,.tsx' --watch",
    test: "jest",
    "test:watch": "jest --watchAll"
  },
  keywords: ["nextcloud"],
  homepage: "https://github.com/nextcloud/nextcloud-event-bus#readme",
  author: "Christoph Wurst",
  license: "GPL-3.0-or-later",
  repository: {
    type: "git",
    url: "https://github.com/nextcloud/nextcloud-event-bus"
  },
  dependencies: {
    "@types/semver": "^7.1.0",
    "core-js": "^3.6.2",
    semver: "^7.3.2"
  },
  devDependencies: {
    "@babel/cli": "^7.6.0",
    "@babel/core": "^7.6.0",
    "@babel/plugin-proposal-class-properties": "^7.5.5",
    "@babel/preset-env": "^7.6.0",
    "@babel/preset-typescript": "^7.6.0",
    "@nextcloud/browserslist-config": "^2.1.0",
    "@rollup/plugin-babel": "^5.3.0",
    "@rollup/plugin-commonjs": "^18.0.0",
    "@rollup/plugin-node-resolve": "^11.2.1",
    "babel-jest": "^26.0.1",
    "babel-plugin-inline-json-import": "^0.3.2",
    jest: "^26.0.1",
    rollup: "^2.47.0",
    "rollup-plugin-inject-process-env": "^1.3.1",
    "rollup-plugin-typescript2": "^0.30.0",
    typedoc: "^0.20.32",
    typescript: "^4.0.2"
  },
  browserslist: ["extends @nextcloud/browserslist-config"]
};

class ProxyBus {
  constructor(bus) {
    _defineProperty(this, "bus", void 0);

    if (typeof bus.getVersion !== 'function' || !(0, _valid.default)(bus.getVersion())) {
      console.warn('Proxying an event bus with an unknown or invalid version');
    } else if ((0, _major.default)(bus.getVersion()) !== (0, _major.default)(this.getVersion())) {
      console.warn('Proxying an event bus of version ' + bus.getVersion() + ' with ' + this.getVersion());
    }

    this.bus = bus;
  }

  getVersion() {
    return packageJson.version;
  }

  subscribe(name, handler) {
    this.bus.subscribe(name, handler);
  }

  unsubscribe(name, handler) {
    this.bus.unsubscribe(name, handler);
  }

  emit(name, event) {
    this.bus.emit(name, event);
  }

}

exports.ProxyBus = ProxyBus;
//# sourceMappingURL=ProxyBus.js.map